import Overview from '@rebuild/materials/shared/widget_shell/Overview.vue';
import MobOverview from '@rebuild/materials/shared/widget_shell/MobOverview.vue';
import MobFull from '@rebuild/materials/shared/widget_shell/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
